import type { PartnerListComponent } from '@/entities/models/page';

// Derived from the schema so the size union stays a single source of truth.
export type LogoSize = NonNullable<PartnerListComponent['logoSize']>;

// Card height per size. 'small' keeps the legacy fixed height (unchanged for
// existing partner lists). 'large' has no fixed height — the card wraps the
// logo, whose size is governed by max-h-45 (see PARTNER_IMAGE_CLASSES).
export const PARTNER_CARD_HEIGHT: Record<LogoSize, string> = {
  small: 'h-22',
  large: '',
};

// Image sizing per size (aspect kept, never distorted):
// - small: legacy behavior (intrinsic size, capped) — kept identical.
// - large: fixed 180px display height (h-45), width from aspect. A CSS height is
//   required here since the card no longer sets one — w-auto/h-auto would defer
//   to the (small) intrinsic pixel size and ignore the width/height attributes.
// 'small' keeps mix-blend-multiply (flattens white boxes behind monochrome
// legacy logos); 'large' omits it so prominent full-color logos render as-is.
export const PARTNER_IMAGE_CLASSES: Record<LogoSize, string> = {
  small: 'w-auto h-auto max-w-9/10 max-h-16 object-contain mix-blend-multiply mx-auto',
  large: 'h-45 w-auto max-w-full object-contain mx-auto',
};

// `sizes` hint for srcset selection, per logo size. Chosen generously enough to
// cover the largest rendered width across the layouts (avoids blur from
// under-fetching; slight over-fetch is negligible for logos).
// - small: legacy fixed width.
// - large: up to ~full width on narrow viewports, ~320px in desktop slots.
export const PARTNER_IMAGE_SIZES: Record<LogoSize, string> = {
  small: '144px',
  large: '(max-width: 640px) 90vw, 320px',
};
